export default __webpack_public_path__ + "static/media/iusd4.8f4ba562.png";